import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-secondary-texts',
  templateUrl: './card-secondary-texts.component.html',
  styleUrl: './card-secondary-texts.component.scss'
})
export class CardSecondaryTextsComponent {
  @Input() textKey!: CardSecondaryTextKey;
}

export type CardSecondaryTextKey = "COST-COVERAGE_TRAVEL-EXPENSES";
